import {HTTP, ERROR} from '@/http-common';
import Router from '@/router';
import Vue from 'vue';

const state = {
  accounts: {
    user_accounts: [],
    showLoading: true,
  }
};

const mutations = {
  SET_USER_ACCOUNTS(state, data) {
    state.accounts.user_accounts = data
  },
  SET_LOADING(state, data) {
    state.accounts.showLoading = data;
  },
  RESET_ACCOUNTS(state) {
    state.accounts.user_accounts = [];
  }
};

const getters = {
  getUserAccounts: state => {
    return state.accounts.user_accounts;
  },
  getUserAccountsLoading: state => {
    return state.accounts.showLoading;
  }
};

const actions = {
  resetUserAccounts: ({commit}) => {
    commit('RESET_ACCOUNTS');
  },
  loadUserAccounts: ({commit}) => {
    commit('SET_LOADING', true);
    return HTTP.post('/accounts')
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_USER_ACCOUNTS', response.data.data.accounts);
          commit('SET_LOADING', false);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
          Router.push({name: 'User Accounts'});
        }
      }).catch(err => {
      console.log(err);
    })
  },
};
export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js